import { render, staticRenderFns } from "./AffiliatePolicies.vue?vue&type=template&id=0826db1f&"
import script from "./AffiliatePolicies.vue?vue&type=script&lang=js&"
export * from "./AffiliatePolicies.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePolicies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports